var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "rt-input__wrapper",
      class: {
        floating: _vm.floatingLabel,
        filled: _vm.inputValue,
        "no-border": _vm.withoutBorder,
        error: _vm.borderError,
      },
    },
    [
      _c(
        "div",
        { staticClass: "rt-input", class: { "rt-input--error": _vm.error } },
        [
          _c("input", {
            ref: "input",
            staticClass: "rt-input__field",
            attrs: {
              autocomplete: _vm.autocomplete,
              type: _vm.inputType,
              name: _vm.name,
              disabled: _vm.disabled,
              placeholder: _vm.placeholder,
              maxlength: _vm.maxLength ? _vm.maxLength : 9999,
              readonly: _vm.readOnly,
              autofocus: _vm.autofocus,
            },
            domProps: { value: _vm.inputVal },
            on: {
              input: _vm.handleUpdateInput,
              blur: function ($event) {
                return _vm.$emit("blur", $event.target.value)
              },
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.$emit("enterPressed", $event.target.value)
              },
            },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "focus-border" }),
        ]
      ),
      _vm._v(" "),
      !_vm.error && _vm.hintExists
        ? _c("div", { staticClass: "rt-input__hint" }, [
            _vm._v(_vm._s(_vm.hint)),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.error && _vm.floatLabelVisible
        ? _c("div", { staticClass: "rt-input__floating" }, [
            _vm._v(_vm._s(_vm.floatingLabel)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "rt-input__error" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "password" && _vm.inputValue
        ? _c(
            "button",
            {
              staticClass: "btn-show-password btn-normal",
              class: { inactive: _vm.inputType === "text" },
              on: { click: _vm.showVisiblePassword },
            },
            [
              _c("img", {
                staticClass: "rt-input__icon",
                attrs: { src: "/assets/app/quiz/icon-eye.svg" },
              }),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }